import Firebase from "firebase";
require("firebase/firestore");
require("firebase/functions");

// Firebase production
const firebaseApp = Firebase.initializeApp({
  apiKey: "AIzaSyCJZjoKzZGtGTvZmgcUc1zmX4b8Fq2VGGg",
  authDomain: "codingbee-playground.firebaseapp.com",
  databaseURL: "https://codingbee-playground.firebaseio.com",
  projectId: "codingbee-playground",
  storageBucket: "codingbee-playground.appspot.com",
  messagingSenderId: "1083288077131",
  appId: "1:1083288077131:web:15f2bc7f2a3bb569845ece",
  measurementId: "G-84WB340EM3"
});

export const db = firebaseApp.database();
export const store = firebaseApp.firestore();
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage().ref();
export const functions = firebaseApp.functions();

export const currentTimestamp = Firebase.database.ServerValue.TIMESTAMP;
export const currentTimestampFirestore = Firebase.firestore.FieldValue.serverTimestamp();
export const firestoreFieldValue = Firebase.firestore.FieldValue;
